import { Injectable } from '@angular/core';
import {HttpObservable, HttpWrapper} from '../../common/http-helpers/http.wrapper';
import {ILoggedInPatient} from "../common/common.types";

@Injectable({
  providedIn: 'root'
})
export class PatientProxy {

  constructor(private httpWrapper: HttpWrapper) {
  }

  public getPatientDetails(): HttpObservable<ILoggedInPatient> {
    return this.httpWrapper.get('PatientPortalPatient', 'GetPatientDetails');
  }

}
